// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTJobItemComposed,
    RESTJobSchedulePolicy,
} from './';

/**
 * @export
 * @interface RESTEditBackupJob
 */
export interface RESTEditBackupJob {
    /**
     * Description of the backup job.
     * @type {string}
     * @memberof RESTEditBackupJob
     */
    description?: string | null;
    /**
     * Type of the backup job.
     * @type {string}
     * @memberof RESTEditBackupJob
     */
    backupType?: RESTEditBackupJobBackupTypeEnum;
    /**
     * Defines whether the job will run right after it is created.
     * @type {boolean}
     * @memberof RESTEditBackupJob
     */
    runNow?: boolean | null;
    /**
     * Array of objects that you want to back up.
     * @type {Array<RESTJobItemComposed>}
     * @memberof RESTEditBackupJob
     */
    selectedItems?: Array<RESTJobItemComposed> | null;
    /**
     * Array of objects that you want to exclude from a backup job scope.
     * @type {Array<RESTJobItemComposed>}
     * @memberof RESTEditBackupJob
     */
    excludedItems?: Array<RESTJobItemComposed> | null;
    /**
     * @type {RESTJobSchedulePolicy}
     * @memberof RESTEditBackupJob
     */
    schedulePolicy?: RESTJobSchedulePolicy;
    /**
     * Backup repository ID.
     * @type {string}
     * @memberof RESTEditBackupJob
     */
    repositoryId?: string | null;
    /**
     * Name of the backup job.
     * @type {string}
     * @memberof RESTEditBackupJob
     */
    name?: string | null;
    /**
     * Defines whether the backup job is enabled.
     * @type {boolean}
     * @memberof RESTEditBackupJob
     */
    isEnabled?: boolean | null;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTEditBackupJobBackupTypeEnum {
    EntireOrganization = 'EntireOrganization',
    SelectedItems = 'SelectedItems'
}

